import { render, staticRenderFns } from "./DistributorDetail.vue?vue&type=template&id=0499ae26&scoped=true&"
import script from "./DistributorDetail.vue?vue&type=script&lang=js&"
export * from "./DistributorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499ae26",
  null
  
)

export default component.exports